// extracted by mini-css-extract-plugin
export var divider = "portableText-module--divider--163c5";
export var listItem = "portableText-module--listItem--31c22";
export var listItemsContainer = "portableText-module--listItemsContainer--9ca15";